<template>
    <div>
        <el-input
        placeholder="输入用户名回车搜索"
        v-model="name"
        style="width: 190px;"
        prefix-icon="el-icon-search"
        clearable
        @keyup.native.enter="CLickMeToSearch(name)">
        </el-input>
        <table v-loading="loading" class="table" style=" margin-top:10px; border: 1px solid #F0F0F0">
            <thead>
                <tr>
                    <th scope="col" width="10%" class="header">用户名</th>
                    <th scope="col" width="10%" class="header">
                        <el-dropdown trigger="click">
                        <span class="el-dropdown-link" style="font-size: 15px;">
                            题号<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                            <el-dropdown-menu split-button:true slot="dropdown">
                                <el-dropdown-item @click.native="ClickMeToSearch1(1)">A</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch1(2)">B</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch1(3)">C</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch1(4)">D</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch1(5)">E</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch1(6)">F</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </th>
                    <th scope="col" width="20%" class="header">
                        <el-dropdown trigger="click">
                        <span class="el-dropdown-link" style="font-size: 15px;">
                            运行结果<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                            <el-dropdown-menu slot="dropdown" style="text-align: center;">
                                <el-dropdown-item @click.native="ClickMeToSearch2('Accept')">Accept</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch2('Wrong Answer')">Wrong Answer</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch2('Compile Error')">Compile Error</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch2('Memory Limit Exceed')">Memory Limit Exceed</el-dropdown-item>
                                <el-dropdown-item @click.native="ClickMeToSearch2('Time limit Exceed')">Time limit Exceed</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </th>
                    <th scope="col" width="12%" class="header">运行时间</th>
                    <th scope="col" width="15%" class="header">使用内存</th>
                    <th scope="col" width="15%" class="header">使用语言</th>
                    <th scope="col" width="18%" class="header">提交时间</th>
                </tr>
            </thead>
            <tbody>
                <tr  class="hover" v-for="item in list" :key="item.id"> <!-- v-show="item.uid === $store.state.me.id" -->
                    <th class="body" scope="row">{{ item.user }}</th>
                    <td class="body">{{ item.contentId }}</td>
                    <td class="body" style="color:#25BBA6;">{{ item.status }}</td>
                    <td class="body">{{ item.runtime }} ms</td>
                    <td class="body">{{ item.memory }} kb</td>
                    <td class="body">{{ item.language }}</td>
                    <td class="body">{{ item.time }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import moment from 'moment';
    import $ from 'jquery'
    export default {
        data() {
            return {
                list:[],

                loading: true,

                name: '',
                id: '',
                status: '',
            }
        },
        mounted() {
            this.readList()
        },
        methods: {
            readList() {
                const vue = this
                const store = this.$store
                const route = this.$route
                console.log(route.params.id)
                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/jdg/competition/submitlist/",
                    type: "POST",
                    data: ({
                        content: route.params.id,
                    }),
                    success(resp) {
                        console.log(resp);
                        vue.list = resp.list
                        for (let i = 0; i < vue.list.length; i ++ ) {
                            vue.list[i].time = moment(vue.list[i].time).format('YYYY-MM-DD HH:mm:ss')
                        }
                        
                        vue.loading = false
                    }
                })
            },
            CLickMeToSearch(name) {
                this.loading = true
                this.name = name
                const vue = this
                const route = this.$route
                const store = this.$store

                let key = 'all'
                if (name !== '' && vue.status === '' && vue.id === '') {
                    key = "user"
                } else if (name === '' && vue.status !== '' && vue.id === '') {
                    key = "status"
                } else if (name === '' && vue.status === '' && vue.id !== '') {
                    key = "contentid"
                } else if (name !== '' && vue.status !== '' && vue.id === '') {
                    key = "userStatus"
                } else if (name !== '' && vue.status === '' && vue.id !== '') {
                    key = "userContentid"
                } else if (name === '' && vue.status !== '' && vue.id !== '') {
                    key = "statusContentid"
                } else if (name !== '' && vue.status !== '' && vue.id !== '') {
                    key = "userStatusContentid"
                }

                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/jdg/competition/search/",
                    type: 'post',
                    data: {
                        key: key,
                        content: [name, vue.status, vue.id, route.params.id],
                    },
                    success(resp) {
                        console.log(resp.data)
                        vue.list = resp.data
                        for (let i = 0; i < vue.list.length; i ++ ) {
                            vue.list[i].time = moment(vue.list[i].time).format('YYYY-MM-DD HH:mm:ss')
                        }
                        vue.loading = false
                    }
                })
            },
            ClickMeToSearch1(id) {
                this.loading = true
                this.id = id
                const vue = this
                const route = this.$route
                const store = this.$store
                console.log("id")
                let key = 'all'
                if (vue.name !== '' && vue.status === '' && vue.id === '') {
                    key = "user"
                } else if (vue.name === '' && vue.status !== '' && vue.id === '') {
                    key = "status"
                } else if (vue.name === '' && vue.status === '' && vue.id !== '') {
                    key = "contentid"
                } else if (vue.name !== '' && vue.status !== '' && vue.id === '') {
                    key = "userStatus"
                } else if (vue.name !== '' && vue.status === '' && vue.id !== '') {
                    key = "userContentid"
                } else if (vue.name === '' && vue.status !== '' && vue.id !== '') {
                    key = "statusContentid"
                } else if (vue.name !== '' && vue.status !== '' && vue.id !== '') {
                    key = "userStatusContentid"
                }

                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/jdg/competition/search/",
                    type: 'post',
                    data: {
                        key: key,
                        content: [vue.name, vue.status, vue.id, route.params.id],
                    },
                    success(resp) {
                        console.log(resp.data)
                        vue.list = resp.data
                        for (let i = 0; i < vue.list.length; i ++ ) {
                            vue.list[i].time = moment(vue.list[i].time).format('YYYY-MM-DD HH:mm:ss')
                        }
                        vue.loading = false
                    }
                })
            },
            ClickMeToSearch2(status) {
                this.loading = true
                this.status = status
                console.log(this.status)
                console.log()
                const vue = this
                const route = this.$route
                const store = this.$store

                let key = 'all'
                if (vue.name !== '' && vue.status === '' && vue.id === '') {
                    key = "user"
                } else if (vue.name === '' && vue.status !== '' && vue.id === '') {
                    key = "status"
                } else if (vue.name === '' && vue.status === '' && vue.id !== '') {
                    key = "contentid"
                } else if (vue.name !== '' && vue.status !== '' && vue.id === '') {
                    key = "userStatus"
                } else if (vue.name !== '' && vue.status === '' && vue.id !== '') {
                    key = "userContentid"
                } else if (vue.name === '' && vue.status !== '' && vue.id !== '') {
                    key = "statusContentid"
                } else if (vue.name !== '' && vue.status !== '' && vue.id !== '') {
                    key = "userStatusContentid"
                }

                console.log("status = ", this.status)
                console.log("id = ", this.id)
                console.log("name = ", this.name)
                console.log("key = ", key)

                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/jdg/competition/search/",
                    type: 'post',
                    data: {
                        key: key,
                        content: [vue.name, vue.status, vue.id, route.params.id],
                    },
                    success(resp) {
                        console.log(resp.data)
                        vue.list = resp.data
                        for (let i = 0; i < vue.list.length; i ++ ) {
                            vue.list[i].time = moment(vue.list[i].time).format('YYYY-MM-DD HH:mm:ss')
                        }
                        vue.loading = false
                    }
                })
            }
        }
    }
</script>

<style scoped>
.body {
    height: auto;
    line-height: auto;
    text-align: center; 
    font-size:14px; 
    font-weight:400;
}
.hover:hover {
    cursor: pointer;
}
.header {
    text-align: center; 
    background-color:#EEEEEE; 
    color: #888888; 
    font-weight:500;
}
</style>